<template>
    <div id="statement_content">
        <div class="content"
        :style="{color: colors.theme == 'dark' ? `#fff` : `#000`}">
            <p v-for="paragraph in content" :key="paragraph.index">{{paragraph.item}}</p>
        </div>
    </div>
</template>

<script>
import {Bus} from '@/event-bus'
export default {
    props:['content', 'index'],
    data: function(){
        return{
            colors: {}
        }
    },
    created(){
        Bus.$on('addIndex', this.getIndex)
        this.colors = JSON.parse(localStorage.getItem("colors"));
    },
    destroyed(){
        Bus.$off('addIndex')  
    },

    methods:{
        getIndex(){
            this.index = this.$store.getters.getReportsAgreementIndex
        }
    }

}
</script>

<style lang="scss">
    #statement_content{
        display: flex;
        padding: 0 25px;
        //height: 55vh !important;

        p{
            padding: 5% 0;
            font-size: 11pt;
            line-height: 20px;

        }
    }

    @media screen and (max-width: 400px){
        #statement_content{
            overflow-y: scroll;
        }
    }
</style>
